import api from '@/api';
import type { ApiResponse } from '@/types/api';
import { ApiFactory } from './base/ApiFactory';

/**
 * Referral join data type
 */
export interface ReferralJoinData {
    gcash_proof: File | Blob | null;
    mobile_number: string;
}

export interface ReferralInfo {
    code: string,
    referralCount: number,
    tier: string,
    startYear: string,
    endYear: string
}

export interface Tiers {
    tier: string,
    minReferrals: number,
    maxReferrals: number,
    cashReward: number,
    installmentReward: number,
}


/**
 * Service class for interacting with the Referral & Earn API endpoints.
 */
class ReferralService extends ApiFactory<any> {
    /**
     * Creates an instance of ReferralService.
     */
    constructor() {
        super('/refer-earn', api);
    }

    /**
     * Joins the referral program.
     * @param data - Referral join data
     * @returns Promise with join response
     */
    async join(data: ReferralJoinData): Promise<ApiResponse<any>> {
        const formData = new FormData();

        if (data.gcash_proof) {
            formData.append('gcash_proof', data.gcash_proof);
        }
        formData.append('mobile_number', data.mobile_number);

        // Debug: Check FormData contents
        for (let pair of formData.entries()) {
            console.log('FormData entry:', pair[0], pair[1]);
        }

        return this.post<ApiResponse<any>>(`${this.resource}/join`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }

    /**
     * Gets the available tier levels and their benefits.
     * @returns Promise with tiers response
     */
    async getTiers(): Promise<ApiResponse<any>> {
        return this.get<ApiResponse<any>>(`${this.resource}/tiers`);
    }

     async getReferralInfo(): Promise<ApiResponse<any>> {
        return this.get<ApiResponse<any>>(`${this.resource}`);
    }

     async getDisbursement(): Promise<ApiResponse<any>> {
        return this.get<ApiResponse<any>>(`${this.resource}/pending-disbursement`);
    }

    async getHistory(): Promise<ApiResponse<any>> {
        return this.get<ApiResponse<any>>(`${this.resource}/history`);
    }

    /**
     * Gets the kaibigan points balance and referral information.
     * @returns Promise with kaibigan points response
     */
    async getKaibiganPoints(): Promise<ApiResponse<any>> {
        return this.get<ApiResponse<any>>(`rewards/kaibigan-points`);
    }


}

export const referralService = new ReferralService();
export default ReferralService;
